export default "__VITE_ASSET__DnVBzkUA__"